import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppForwardingContainer } from "@/features/settings/whatsapp-forwarding";
import { useFeatureFlagEnabled } from "posthog-js/react";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/whatsapp-weiterleitung",
)({
  component: WhatsAppForwardingPage,
});

function WhatsAppForwardingPage() {
  const whatsappIntegrationEnabled = useFeatureFlagEnabled(
    "whatsapp-integration",
  );

  if (!whatsappIntegrationEnabled) {
    return null;
  }

  return <WhatsAppForwardingContainer />;
}
